module.exports = __webpack_public_path__ + "img/cslogo.c00322c5.svg";